import { render } from "./RenterStatement.vue?vue&type=template&id=28ffab54&scoped=true"
import script from "./RenterStatement.vue?vue&type=script&lang=js"
export * from "./RenterStatement.vue?vue&type=script&lang=js"

import "./RenterStatement.vue?vue&type=style&index=0&id=28ffab54&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ffab54"]])

export default __exports__